import { render } from "./Wave.vue?vue&type=template&id=73fd1b52"
import script from "./Wave.vue?vue&type=script&lang=js"
export * from "./Wave.vue?vue&type=script&lang=js"

import "./Wave.vue?vue&type=style&index=0&id=73fd1b52&lang=scss"

import exportComponent from "/Users/documedias/gitlab/virtuell/unionconf2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__